import { MediaProgramGuide } from '@calm/evexia-web-sdk';

export function sortGuides(a: MediaProgramGuide, b: MediaProgramGuide) {
    if (a.position === b.position) {
        return 0;
    }
    return a.position > b.position ? 1 : -1;
}
